var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6,6 L6,9 L4,9 L4,17 L12,17 L12,15 L15,15 L15,18.9931545 C15,19.5492199 14.5500512,20 13.9931545,20 L2.00684547,20 C1.45078007,20 1,19.5500512 1,18.9931545 L1,7.00684547 C1,6.45078007 1.44994876,6 2.00684547,6 L6,6 Z M6,2.00684547 C6,1.45078007 6.44994876,1 7.00684547,1 L18.9931545,1 C19.5492199,1 20,1.44994876 20,2.00684547 L20,13.9931545 C20,14.5492199 19.5500512,15 18.9931545,15 L7.00684547,15 C6.45078007,15 6,14.5500512 6,13.9931545 L6,2.00684547 Z M9,4 L9,12 L17,12 L17,4 L9,4 Z"
})))));
export default SvgCopy;